import Support from 'src/app/Support/Support'

export default Support
